import React from 'react';
import Button from 'components/Button';
import ModalCustom from 'components/Modal';
import { toast } from 'react-toastify';
import { CompanyOverview } from 'data/models/company.model';

type TModalDeactivateCompanyProps = {
  modalActiveDialog: boolean;
  setModalActiveDialog: any;
  setIsActive: any;
  handleCreateOrUpdateCompany: () => void;
  value: boolean;
  setModalParentDialog: any;
  isParentCompany: boolean;
  parentCompany: CompanyOverview | undefined;
};

export const ModalDeactivateCompany: React.FC<TModalDeactivateCompanyProps> = ({
  modalActiveDialog,
  setModalActiveDialog,
  setIsActive,
  handleCreateOrUpdateCompany,
  value,
  setModalParentDialog,
  isParentCompany,
  parentCompany,
}) => {
  const handleCancelActive = () => {
    setModalActiveDialog(false);
    setIsActive(true);
  };

  const handleSubmitSave = async () => {
    setModalActiveDialog(false);
    setIsActive(false);
    if (value) {
      try {
        if (!isParentCompany) {
          handleCreateOrUpdateCompany();
        } else {
          if (parentCompany) {
            setModalParentDialog(true);
          } else {
            handleCreateOrUpdateCompany();
          }
        }
      } catch (error) {
        toast.error('error');
      }
    }
  };

  return (
    <ModalCustom
      title={'Are you sure you want to deactivate this Company?'}
      open={modalActiveDialog}
      subTittle={
        'Deactivating this company will  deactivate landing pages and registration links tied to this company. Users tied to this company will NOT be deactivated - you will need to do this manually. '
      }
      handleClose={handleCancelActive}
      groupButton={
        <>
          <Button
            onClick={handleCancelActive}
            variant="outlined"
            sx={{
              fontWeight: 700,
              fontSize: '14px',
              lineHeight: '20px',
              border: '1px solid #213B54',
              width: '97px',
              height: '40px',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitSave}
            variant="contained"
            color="primary"
            sx={{
              fontWeight: 700,
              fontSize: '14px',
              lineHeight: '20px',
              width: '97px',
              height: '40px',
            }}
          >
            Save
          </Button>
        </>
      }
    />
  );
};
